import PageBanner from "components/BannerSection/PageBanner";
import CallToSectionTwo from "components/CallToSection/CallToSectionTwo";
import HeaderOne from "components/Header/HeaderOne";
import MobileMenu from "components/Header/MobileMenu";
import Layout from "components/Layout/Layout";
import MainFooter from "components/MainFooter/MainFooter";
import Style from "components/Reuseable/Style";
import SearchPopup from "components/SearchPopup/SearchPopup";
import React from "react";
import GallerySectionTwo from "components/GallerySection/GallerySectionTwo";
const BountyCreative = () => {
  return (
    <Layout pageTitle="Bounty Creative">
      <Style />
      <HeaderOne />
      <MobileMenu />
      <SearchPopup />
      <PageBanner
        title="Bounty Creative"
        parent="Services"
        parentHref="/bounty-creative"
      />
      <GallerySectionTwo portfolio />
      <CallToSectionTwo className="alternate" />
      <MainFooter />
    </Layout>
  );
};

export default BountyCreative;
